import React, { Component } from "react";
import KioskoForm from "../KioskoForm/KioskoForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : KioskoPage
Description : Compoente que alberga el formulario de Kiosko definido en el directorio de componentes
Date Autor Modification
================================================================================
29/09/2022 Santiago Coca - Se define el componente
================================================================================ */

class KioskoPage extends Component {
    render() {
        return (
            <div>
                <KioskoForm />
            </div>
        )
    }
}

export default KioskoPage;